export enum ConfigurationGroupType {
    Detection = 1,
    Recording = 2,
    Care = 3,
    Monitoring = 4,
    Reporting = 5,
}
